import { Popover } from '@headlessui/react';
import ChevronUp from 'svg/ChevronUp';
import classNames from 'styles/utils/classNames';
import { DistanceDropdownProps, ExploreAllMarketPlacesTypesEnum } from './props';
import { getDistanceOptions } from './utils';

const DistanceDropdown: React.FC<DistanceDropdownProps> = ({
  handleDistanceChange,
  distance,
  activeTabValue,
}) => {
  const options = getDistanceOptions(activeTabValue as ExploreAllMarketPlacesTypesEnum);

  return (
    <div className="hidden shrink-0 items-center gap-2 md:flex">
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button className="typography-product-button-label-medium flex w-[11.25rem] items-center justify-between gap-2 bg-color-bg-input-lightmode-primary px-4 py-3 dark:bg-color-bg-darkmode-primary md:rounded-full">
              <span>{distance.name}</span>
              <ChevronUp
                className={classNames(
                  'h-4 w-4 shrink-0 rotate-180 transition-transform',
                  open && '!rotate-0',
                )}
              />
            </Popover.Button>
            <Popover.Panel className="absolute z-10 mt-2 w-full rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary p-ds-md shadow-lg dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary">
              <div className="flex flex-col gap-1">
                {options.map((option) => (
                  <button
                    key={option.id}
                    onClick={() => {
                      handleDistanceChange(option);
                      close();
                    }}
                    className={classNames(
                      'typography-product-button-label-medium rounded-xl border border-transparent p-ds-md text-left text-color-text-lightmode-secondary transition-all hover:border-color-bg-lightmode-icon dark:text-color-text-darkmode-secondary hover:dark:border-color-bg-darkmode-icon',
                      distance.id === option.id &&
                        '!border-color-bg-lightmode-icon dark:!border-color-bg-darkmode-icon',
                    )}
                  >
                    {option.name}
                  </button>
                ))}
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default DistanceDropdown;
